export const tableColumns = [
  {
    key: "Account",
    dataIndex: "Account",
    title: "Account",
    order: "60",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "AccountA",
    dataIndex: "AccountA",
    title: "A/C",
    order: "70",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "CanceledByClOrdID",
    dataIndex: "CanceledByClOrdID",
    title: "CanceledByClOrdID",
    order: "90",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "ClOrdID",
    dataIndex: "ClOrdID",
    title: "ClOrdID",
    order: "10",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "ExchID",
    dataIndex: "ExchID",
    title: "ExchID",
    order: "100",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "FreeText",
    dataIndex: "FreeText",
    title: "FFT",
    order: "80",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "LimitPx",
    dataIndex: "LimitPx",
    title: "LmtPx",
    order: "50",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "OrdStatus",
    dataIndex: "OrdStatus",
    title: "Status",
    order: "20",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "Qty",
    dataIndex: "Qty",
    title: "Qty",
    order: "35",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "Side",
    dataIndex: "Side",
    title: "B/S",
    order: "30",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "Symbol",
    dataIndex: "Symbol",
    title: "Symbol",
    order: "40",
    longName: "Y",
    tooltip: ""
  },
  {
    key: "User",
    dataIndex: "User",
    title: "User",
    order: "110",
    longName: "Y",
    tooltip: ""
  }

  //

  //
  //
  //
  //
];
